import { NgModule } from '@angular/core';
import { MenuComponent } from './menu.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular/lazy';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, FontAwesomeModule, TranslateDirective, TranslatePipe, SharedModule, RouterModule],
  exports: [MenuComponent],
  declarations: [MenuComponent],
})
export class MenuModule {}
